///** 
// * Datatable asynchrone pour afficher des résultats de recherche.
// *
// * handler          string                                      URL du handler HTTP
// * pageLength       int                                         Nombre de résultats par page
// * columns          array{name, title, sortable, formatter}     Liste des descripteurs des colonnnes  
// * onUpdate         void function(data)                         Callback appellé quand des données sont reçues du serveur
// * drawCallback     void function()                             Callback appellé quand la table vient d'être réécrite
// * criteria         object                                      Critères de recherche
// */
//(function ($) {
//    'use strict';

//    $.fn.searchPage = function (options) {
//        return searchPage($(this), options);
//    };

//    let searchPage = function ($self, options) {
//        let _defaultOptions = {
//            pageLength: 20,
//            start: 0,
//            sortColumnDir: "asc",
//            sortColumnName: "default",
//            criteria: {},
//            ajaxHandler: null,
//            ajaxCallback: function (d, status, xhr) { },
//            // return scrollPos >= $self.offset().top + $self.height();
//        };
//        let _options = $.extend({}, _defaultOptions, options);

//        if (!_options.ajaxHandler) {
//            console.error("BRC.searchPage : Init error > ajaxHandler option is undefined");
//        }

//        function init() {
//            let _setOption = function (path, value) {
//                let schema = _options;
//                let pList = path.split('.');
//                let len = pList.length;
//                for (let i = 0; i < len - 1; i++) {
//                    let key = pList[i];
//                    schema = schema[key] || {};
//                }

//                schema[pList[len - 1]] = value;

//                //_options = schema;
//                return this;
//            };

//            let _reset = function () {
//                _options.start = 0;
//                fetchData(_options.resetCallback);
//                return this;
//            };

//            $(document).on('scroll', function () {
//                if (_options.scroller && _options.scroller.enable) {
//                    if (_options.scroller.loadTrigger($(window).height() + $(window).scrollTop())) {
//                        _options.scroller.onUpdate();
//                        load();
//                    }
//                }
//            });
//            _options.initCallback();

//            if (!_options.deferLoading) {
//                _options.start -= _options.pageLength;
//                load();
//            }

//            return {
//                set: _setOption,
//                reset: _reset
//            };
//        }

//        function load() {
//            _options.start += _options.pageLength;
//            fetchData(_options.loadCallback);
//        }

//        function fetchData (callback) {
//            $.ajax({
//                dataType: 'html',
//                type: 'POST',
//                url: _options.ajaxHandler,
//                data: requestData()
//            })
//                .done(function (data, status, xhr) {
//                    _options.ajaxCallback(data, status, xhr);
//                    callback(data);
//                })
//                .fail(function (xhr, status, error) {
//                    console.error('BRC.searchPage : Ajax loading error', status, error);
//                    _options.ajaxCallback(null, status, xhr);
//                });
//        }

//        function requestData() {
//            return {
//                Start: _options.start,
//                Length: _options.pageLength,
//                SortColumn: options.sortColumnName,
//                SortDir: options.sortColumnDir,
//                Criteria: isFunction(options.criteria) ? options.criteria() : options.criteria
//            };

//            function isFunction(obj) {
//                return !!(obj && obj.constructor && obj.call && obj.apply);
//            }
//        }

//        return init();
//    };
//})(jQuery);
